import _debounce from 'lodash/debounce';
import {
  Dispatch,
  SetStateAction,
  useCallback,
  useMemo,
  useState,
} from 'react';
import { useIntl } from 'react-intl';

import SearchIcon from '@/assets/icons/search.svg';
import { Input } from '@/components/ui/input';

interface SearchProps {
  setSearchQuery: Dispatch<SetStateAction<string>>;
}

export function Search({ setSearchQuery }: SearchProps) {
  const intl = useIntl();
  const [inputValue, setInputValue] = useState('');

  const debouncedSetSearchQuery = useMemo(
    () => _debounce((value: string) => setSearchQuery(value), 500),
    [setSearchQuery],
  );

  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      setInputValue(value);
      debouncedSetSearchQuery(value);
    },
    [debouncedSetSearchQuery],
  );

  return (
    <Input
      placeholderIcon={SearchIcon}
      placeholder={intl.formatMessage({
        defaultMessage: 'Type to filter...',
      })}
      className="max-w-[340px]"
      value={inputValue}
      onChange={handleInputChange}
    />
  );
}
